import React, { useState, useEffect } from 'react';
import useApi from '../../hooks/useApi';
import { X, ShieldAlert, Globe } from 'lucide-react';

const EditEntityModal = ({ entity, onClose, onEntityUpdated, allCurrencies }) => {
    const { apiFetch } = useApi();
    const [name, setName] = useState('');
    const [type, setType] = useState('CNPJ');
    const [identifier, setIdentifier] = useState('');
    const [status, setStatus] = useState('ativo');
    const [logo, setLogo] = useState(null);
    const [defaultCurrency, setDefaultCurrency] = useState('BRL');
    const [businessType, setBusinessType] = useState('general');
    
    // FLAG MONITORAMENTO
    const [useMonitoring, setUseMonitoring] = useState(0);
    // FLAG DE LICENCIAMENTO
    const [maxUsers, setMaxUsers] = useState(5);
    // NOVO: FLAG ACESSO CLIENTES
    const [allowClientAccess, setAllowClientAccess] = useState(0);
    
    // NOVOS ESTADOS
    const [country, setCountry] = useState('');
    const [stateRegistration, setStateRegistration] = useState('');
    const [addressStreet, setAddressStreet] = useState('');
    const [addressNumber, setAddressNumber] = useState('');
    const [addressComplement, setAddressComplement] = useState('');
    const [addressCity, setAddressCity] = useState('');
    const [addressState, setAddressState] = useState('');
    const [addressZip, setAddressZip] = useState('');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (entity) {
            setName(entity.name);
            setType(entity.type);
            setIdentifier(entity.identifier);
            setStatus(entity.status || 'ativo');
            setDefaultCurrency(entity.defaultCurrency || 'BRL');
            setBusinessType(entity.business_type || 'general');
            
            // FLAG MONITORAMENTO E LICENÇAS
            setUseMonitoring(entity.use_monitoring || 0);
            setMaxUsers(entity.max_users || 5);
            // NOVO: FLAG ACESSO CLIENTES
            setAllowClientAccess(entity.allow_client_access || 0);
            
            // NOVO: Preenche os novos estados
            setCountry(entity.country || '');
            setStateRegistration(entity.state_registration || '');
            setAddressStreet(entity.address_street || '');
            setAddressNumber(entity.address_number || '');
            setAddressComplement(entity.address_complement || '');
            setAddressCity(entity.address_city || '');
            setAddressState(entity.address_state || '');
            setAddressZip(entity.address_zip || '');
        }
    }, [entity]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);

        const formData = new FormData();
        formData.append('name', name);
        formData.append('type', type);
        formData.append('identifier', identifier);
        formData.append('status', status);
        formData.append('defaultCurrency', defaultCurrency);
        formData.append('business_type', businessType);
        
        // ENVIO DA FLAG
        formData.append('use_monitoring', useMonitoring);
        formData.append('max_users', maxUsers);
        // NOVO: ENVIO ACESSO CLIENTES
        formData.append('allow_client_access', allowClientAccess);

        // NOVO: Adiciona os novos campos ao FormData
        formData.append('country', country);
        formData.append('state_registration', stateRegistration);
        formData.append('address_street', addressStreet);
        formData.append('address_number', addressNumber);
        formData.append('address_complement', addressComplement);
        formData.append('address_city', addressCity);
        formData.append('address_state', addressState);
        formData.append('address_zip', addressZip);

        if (logo) {
            formData.append('logo', logo);
        }

        try {
            await apiFetch(`/entities/${entity.id}`, {
                method: 'PUT',
                body: formData
            });
            setSuccess('Entidade atualizada com sucesso!');
            setTimeout(() => {
                onEntityUpdated();
            }, 1000);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
             {/* MODIFICADO: Aumentado para max-w-2xl e max-h-[80vh] para caber o endereço */}
             <div className="w-full max-w-2xl p-6 bg-white rounded-lg shadow-xl" onClick={e => e.stopPropagation()}>
                 <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-bold">Editar Entidade</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200"><X /></button>
                </div>
                 {/* MODIFICADO: Adicionado max-h-[80vh] e overflow-y-auto */}
                 <form onSubmit={handleSubmit} className="p-4 mt-4 space-y-4 border rounded-lg bg-gray-50 max-h-[80vh] overflow-y-auto">
                    {error && <p className="text-sm text-red-600">{error}</p>}
                    {success && <p className="text-sm text-green-600">{success}</p>}
                    
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                            <label className="text-sm font-medium">Nome da Entidade</label>
                            <input type="text" value={name} onChange={e => setName(e.target.value)} required className="w-full p-2 mt-1 border rounded" />
                        </div>
                        <div>
                            <label className="text-sm font-medium">Tipo</label>
                            <select value={type} onChange={e => setType(e.target.value)} className="w-full p-2 mt-1 border rounded">
                                <option value="CNPJ">CNPJ</option>
                                <option value="CPF">CPF</option>
                            </select>
                        </div>
                        <div>
                            <label className="text-sm font-medium">Identificador (CNPJ/CPF)</label>
                            <input type="text" value={identifier} onChange={e => setIdentifier(e.target.value)} required className="w-full p-2 mt-1 border rounded" />
                        </div>
                        <div>
                            <label className="text-sm font-medium">Status</label>
                            <select value={status} onChange={e => setStatus(e.target.value)} className="w-full p-2 mt-1 border rounded">
                                <option value="ativo">Ativo</option>
                                <option value="inativo">Inativo</option>
                            </select>
                        </div>
                        <div>
                            <label className="text-sm font-medium">Moeda Padrão</label>
                            <select value={defaultCurrency} onChange={e => setDefaultCurrency(e.target.value)} required className="w-full p-2 mt-1 border rounded">
                                {allCurrencies.map(c => <option key={c.code} value={c.code}>{c.name} ({c.symbol})</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="text-sm font-medium">Tipo de Negócio</label>
                            <select value={businessType} onChange={e => setBusinessType(e.target.value)} className="w-full p-2 mt-1 border rounded">
                                <option value="general">Geral</option>
                                <option value="pet">Pet</option>
                                <option value="energia">Energia</option>
                            </select>
                        </div>

                        <div className="md:col-span-2">
                            <label className="text-sm font-medium">Limite de Usuários (Licenças)</label>
                            <input type="number" value={maxUsers} onChange={e => setMaxUsers(e.target.value)} min="1" required className="w-full p-2 mt-1 border rounded" />
                        </div>

                        {/* CAMPO MONITORAMENTO ENTIDADE */}
                        <div className="md:col-span-2 flex items-center gap-2 bg-blue-50 p-2 rounded border border-blue-200">
                             <input 
                                type="checkbox" 
                                id="edit_ent_monitoring"
                                checked={useMonitoring === 1} 
                                onChange={(e) => setUseMonitoring(e.target.checked ? 1 : 0)}
                                className="w-4 h-4 text-blue-600 rounded"
                             />
                             <label htmlFor="edit_ent_monitoring" className="text-sm font-bold text-blue-800 flex items-center gap-1">
                                <ShieldAlert size={16} /> Ativar monitoramento de PC para esta empresa
                             </label>
                        </div>

                        {/* NOVO: CAMPO PERMITIR ACESSO CLIENTES */}
                        <div className="md:col-span-2 flex items-center gap-2 bg-green-50 p-2 rounded border border-green-200">
                             <input 
                                type="checkbox" 
                                id="edit_allow_client_access"
                                checked={allowClientAccess === 1} 
                                onChange={(e) => setAllowClientAccess(e.target.checked ? 1 : 0)}
                                className="w-4 h-4 text-green-600 rounded"
                             />
                             <label htmlFor="edit_allow_client_access" className="text-sm font-bold text-green-800 flex items-center gap-1">
                                <Globe size={16} /> Permitir acesso clientes ao sistema
                             </label>
                        </div>
                        
                        {/* NOVOS CAMPOS (País e Insc. Estadual) */}
                        <div>
                            <label className="text-sm font-medium">País</label>
                            <input type="text" value={country} onChange={e => setCountry(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                        </div>
                         <div>
                            <label className="text-sm font-medium">Insc. Estadual</label>
                            <input type="text" value={stateRegistration} onChange={e => setStateRegistration(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                        </div>

                        <div className="md:col-span-2">
                            <label className="text-sm font-medium">Logomarca (opcional)</label>
                            <input type="file" accept="image/png" onChange={e => setLogo(e.target.files[0])} className="w-full p-2 mt-1 text-sm border rounded" />
                            <p className="text-xs text-gray-500 mt-1">PNG quadrado (ex: 256x256 pixels). Máx 2MB.</p>
                        </div>
                    </div>
                    
                    {/* NOVO GRUPO: Endereço */}
                    <div className="pt-4 border-t">
                        <h3 className="text-lg font-semibold">Endereço</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                            <div className="md:col-span-2">
                                <label className="text-sm font-medium">Rua/Avenida</label>
                                <input type="text" value={addressStreet} onChange={e => setAddressStreet(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Nº</label>
                                <input type="text" value={addressNumber} onChange={e => setAddressNumber(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                            </div>
                            <div className="md:col-span-3">
                                <label className="text-sm font-medium">Complemento</label>
                                <input type="text" value={addressComplement} onChange={e => setAddressComplement(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Cidade</label>
                                <input type="text" value={addressCity} onChange={e => setAddressCity(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Estado</label>
                                <input type="text" value={addressState} onChange={e => setAddressState(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                            </div>
                            <div>
                                <label className="text-sm font-medium">CEP</label>
                                <input type="text" value={addressZip} onChange={e => setAddressZip(e.target.value)} className="w-full p-2 mt-1 border rounded" />
                            </div>
                        </div>
                    </div>
                    
                     <div className="flex justify-end gap-2 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 font-semibold bg-gray-200 rounded-md">Fechar</button>
                        <button type="submit" disabled={loading} className="px-4 py-2 font-semibold text-white bg-blue-600 rounded-md">
                            {loading ? 'A guardar...' : 'Guardar Alterações'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditEntityModal;